import { event, setOptions, bootstrap } from 'vue-gtag';
import { ANALYTICS_KEY } from '@/../region.json';

export const cookiesKey = 'qwello-cookies';

/** Send events to google analytics
 * @param {string} name -> 'Click' | 'Login' etc
 * @param {{event_category: string, event_label: string}} opts -> event_category: 'FAQPage', event_label: "How do I change my email address?"
 */
export function sendAnalytics(name, opts) {
  event(name, opts);
}
// enable google analytics and return a promise to set localstorage.setItem('qwello-cookies': true)
export function enableAnalytics() {
  setOptions({
    config: { id: process.env[ANALYTICS_KEY] },
  });

  return bootstrap();
}
